import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-kiln-firing-log',
  templateUrl: './kiln-firing-log.component.html',
  styleUrls: ['./kiln-firing-log.component.scss'],
})
export class KilnFiringLogComponent implements OnChanges {
  @Input() externalId: string;
  @Input() inAdminPage: boolean;
  public logName: string = ""
  public s3LogPath: string = ""
  public urlVisible: boolean = false;
  public urlString: string = "";
  public gotFilename: boolean = false;
  public allLogFiles: any[] = [];


  constructor(
    private logService: LogService,
    private inAppBrowser: InAppBrowser,
    private alertController: AlertController,
    private toastController: ToastController,
  ) {}

  ngOnChanges() {
    this.logName = "";
    this.allLogFiles = [];
    this.logService.logfiles.subscribe((logFiles) => {
      let logFilesForKiln = logFiles[this.externalId]
      if(logFilesForKiln?.length > 0) {
        this.gotFilename = true;

        let lastLog = logFilesForKiln[ logFilesForKiln.length - 1 ]
        this.logName = lastLog?.name;
        this.s3LogPath = lastLog?.s3PathName;
        
        // Store all logs except the latest one (which is shown separately)
        // Add parsed firing number to each log
        this.allLogFiles = logFilesForKiln.slice(0, -1).reverse().map(log => ({
          ...log,
          firingNumber: this.parseFiringNumber(log.name)
        })).filter((log) => {
          return log.firingNumber != 'null' && log.firingNumber != '' && log.firingNumber != 'undefined'
        });
      }
    })

    this.logService.getLogFileNames(this.externalId).catch(() => {
      this.showMessage(`Error loading kiln logs. Pull down to refresh`, 'toast-failure')
    })
  }

  parseFiringNumber(filename: string): string | null {
    if (!filename) return null;
    // Format: serialNumber_firingNumber_firingLog.csv
    const parts = filename.split('_');
    if (parts.length >= 2 && parts[1] && parts[1].trim() !== '') {
      return parts[1].trim(); // Return the firing number (second part)
    }
    return null;
  }

  async downloadFromAdminPage() {
    this.logService.downloadLog(this.externalId, this.s3LogPath).then((response) => {
      this.urlString = JSON.stringify(response.url);

      this.inAppBrowser.create(response.url, '_system')
    }).catch((error) => {
      console.log("KilnLink Log: Error downloading file. " + JSON.stringify(error))
      this.showMessage(`Error downloading kiln log. Please try again`, 'toast-failure')
    })
  }

  async downloadWithApprovalPopup() {
    let alert = await this.alertController.create({
      header: "Download the log file?",
      message: `Please confirm you want to download the log file.`,
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'primary',
          role: 'cancel'
        }, {
          text: "Download",
          cssClass: 'secondary',
          handler: (data) => {
            this.logService.downloadLog(this.externalId, this.s3LogPath).then((response) => {
              this.urlString = JSON.stringify(response.url);

              this.inAppBrowser.create(response.url, '_system')
            }).catch((error) => {
              console.log("KilnLink Log: Error downloading file. " + JSON.stringify(error))
              this.showMessage(`Error downloading kiln log. Please try again`, 'toast-failure')
            })
          }
        }
      ]
    });
    alert.present();
  }

  async download(){
    if (this.inAdminPage){
      this.downloadFromAdminPage();
    } else {
      this.downloadWithApprovalPopup()
    }
  }

  async downloadLog(logFile: any) {
    if (this.inAdminPage) {
      this.logService.downloadLog(this.externalId, logFile.s3PathName).then((response) => {
        this.inAppBrowser.create(response.url, '_system')
      }).catch((error) => {
        console.log("KilnLink Log: Error downloading file. " + JSON.stringify(error))
        this.showMessage(`Error downloading kiln log. Please try again`, 'toast-failure')
      })
    } else {
      let alert = await this.alertController.create({
        header: "Download the log file?",
        message: `Please confirm you want to download ${logFile.name}.`,
        buttons: [
          {
            text: 'Cancel',
            cssClass: 'primary',
            role: 'cancel'
          }, {
            text: "Download",
            cssClass: 'secondary',
            handler: (data) => {
              this.logService.downloadLog(this.externalId, logFile.s3PathName).then((response) => {
                this.inAppBrowser.create(response.url, '_system')
              }).catch((error) => {
                console.log("KilnLink Log: Error downloading file. " + JSON.stringify(error))
                this.showMessage(`Error downloading kiln log. Please try again`, 'toast-failure')
              })
            }
          }
        ]
      });
      alert.present();
    }
  }

  async showMessage(message, cssClass = 'toast-success') {
    let toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'top',
      cssClass: cssClass
    });

    toast.present();
  }

}
